import React from "react";
import UniversalButton from "components/uiComponents/UniversalButton";
import "./ScoreWindow.scss";
import { useHistory } from "react-router-dom";
import { useDashboardState } from "../../DashboardContext";
import Rating from "../Ratting";

const ScoreWindow = ({managerQuickInfoScore, score}) => {
  const { setIsTableHidden } = useDashboardState();
  const history = useHistory();
  const handleCancel = () => {
    history.push("/");
  };


  const showResult = () => {
    managerQuickInfoScore(true);
    setIsTableHidden(false);
  };

  return (
    <div className={'score-window-wrapper'}>
        <div className={"score-window"}>
          <div className={"score-window_info"}>
              <Rating isEditable={false} initialRatting={score}/>
            <h6>Your score</h6>
          </div>

          <div className={"score-window_circle"}>
          </div>

          <div className="score-window_btns">
            <UniversalButton
              type={"submit"}
              label={"Show results"}
              size={"lg"}
              labelColor={"white"}
              backgroundColor={"blue-dark"}
              backgroundHoverColor={'blue-light'}
              onClick={showResult}
            />

            <div className={'score-window_btn'}>
              <UniversalButton
                type={"button"}
                label={"Cancel & go back"}
                size={"lg"}
                labelColor={"blue"}
                backgroundColor={"none"}
                backgroundHoverColor={'blue-light'}
                onClick={handleCancel}
              />
            </div>
          </div>
        </div>
      </div>
  );
};

export default ScoreWindow;
